
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({
      modal: "modal/modal-receipt-vin/modal"
    }),
    getCarComponent() {
      return this.$device.isMobile
        ? "catalog-item-large-mobile"
        : "catalog-item-small-desktop";
    },
    carComponentShouldRender() {
      return !this.$device.isMobile && this.modal.offerData?.mark;
    }
  },
  methods: {
    ...mapActions({
      openModal: "modal/modal-receipt-vin/openModal",
      closeModal: "modal/modal-receipt-vin/closeModal"
    })
  },
};
